import React, { useState } from 'react';
import { Button } from '@mui/material';
import { reportToSegment, types, eventNames } from '@smartcar/morse';
import { func, string } from 'prop-types';
import BoltIcon from '@mui/icons-material/Bolt';

import UpsellModal from '../UpsellModal';

const UpgradeButton = ({ text, feature, handleClick }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(false);
  const handleButtonClick = () => {
    if (handleClick) {
      handleClick();
    } else {
      setModalOpen(true);
    }
    reportToSegment(types.TRACK, eventNames.modalOpened, {
      label: `upsell (${feature})`,
      title: text,
    });
  };

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="warning"
        onClick={handleButtonClick}
        id="upgrade-button"
        startIcon={<BoltIcon />}
      >
        {text}
      </Button>
      {modalOpen && <UpsellModal feature={feature} toggleModal={toggleModal} />}
    </React.Fragment>
  );
};

UpgradeButton.propTypes = {
  text: string.isRequired,
  feature: string.isRequired,
  handleClick: func,
};

UpgradeButton.defaultProps = {
  handleClick: null,
};

export default UpgradeButton;
